/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2022, Zumper
 */

// https://chakra-ui.com/docs/styled-system/theming/component-style#styling-single-part-components

import type { ComponentStyleConfig } from '@chakra-ui/theme'

export const Z4Switch: ComponentStyleConfig = {
  baseStyle: {
    label: {
      fontFamily: 'body',
    },
    track: {
      _checked: {
        bg: 'pink.600',
      },
    },
  },
  defaultProps: {
    colorScheme: 'pink',
    size: 'md',
  },
}
